<template>
  <div class="popover-content">
    <div class="product-search">
      <input
        v-model="search"
        type="text"
        placeholder="Haku..."
        class="input pm-input mb-5"
      />

      <ul class="product-list">
        <li class="mt-1" v-for="product in filteredProducts" :key="product.id" @click="goToProductDetail(product.slug)">
          {{ product.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import asModalDialogMixin from "@/helpers/modalMixing"

export default {
  name: 'searchModal',
  mixins: [
    asModalDialogMixin
  ],
  data() {
    return {
      search: ''
    }
  },
  methods: {
    goToProductDetail(productSlug) {
      this.$router.push({
        name: "ProductDetail",
        params: {
          productSlug: productSlug
        },
      });
    }
  },
  computed: {
    products() {
      return this.$store.getters.getProducts
    },
    filteredProducts() {
      if (this.search == '') return []

      return this.products.filter(product =>
          product.name
              .toLowerCase()
              .includes(this.search.toLowerCase())
      )
    }
  }
}
</script>

<style lang="scss" scoped>

.popover-content {
  z-index: 10;
  position: absolute;
  background-color: white;
  width: 400px;
  right: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 50px;
  padding-left: 50px;
  border: 1px solid black;
  top: 80px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;

  @media (max-width: 768px) {
    width: 100%;
    right: 0;
  }
  button {
    width: 150px;
  }
}

ul.product-list {
  li:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

</style>
